import React from 'react';
import { Typography, Divider, Card } from 'antd';
import Navbar from './Navbar';
import Footer from '../component/Footer';

const { Title, Paragraph, Text } = Typography;

const ShippingPolicy = () => {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
            <Navbar />
            <div style={{ flex: 1, padding: '60px 20px', display: 'flex', justifyContent: 'center' }}>
                <Card 
                    bordered={false} 
                    style={{ 
                        width: '100%', 
                        maxWidth: 1000, 
                        borderRadius: 24, 
                        boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                        padding: '20px 40px' 
                    }}
                >
                    <Title level={1} style={{ color: '#0B1F4D', fontWeight: 800, textAlign: 'center', marginBottom: 10 }}>Shipping Policy</Title>
                    <div style={{ textAlign: 'center', marginBottom: 30 }}>
                        <Text type="secondary" style={{ fontSize: 16 }}>
                            Last Updated: {new Date().toLocaleDateString()}
                        </Text>
                    </div>
                    <Divider style={{ borderColor: '#FF8110', borderWidth: 2, width: '100px', minWidth: '100px', margin: '0 auto 40px auto' }} />
                    
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Thank you for visiting and shopping at Nearzon. Following are the terms and conditions that constitute our Shipping Policy. We strive to deliver your products as quickly and safely as possible.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>1. Domestic Shipping Policy</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        <Text strong style={{ color: '#0B1F4D' }}>Shipment processing time:</Text> All orders are processed within 1-3 business days. Orders are not shipped or delivered on weekends or holidays. If we are experiencing a high volume of orders, shipments may be delayed by a few days. Please allow additional days in transit for delivery.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>2. Shipping Rates & Delivery Estimates</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Shipping charges for your order will be calculated and displayed at checkout. Delivery delays can occasionally occur depending on the destination and courier services. We partner with top logistics providers to ensure fast delivery.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>3. Shipment Confirmation & Order Tracking</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        You will receive a Shipment Confirmation email or SMS once your order has shipped containing your tracking number(s). The tracking number will be active within 24 hours. You can also track your order from your Nearzon account dashboard.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>4. Customs, Duties and Taxes</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Nearzon is not responsible for any customs and taxes applied to your order. All fees imposed during or after shipping are the responsibility of the customer (tariffs, taxes, etc.). Please be aware of your local regulations before ordering internationally.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>5. Damages and Lost Packages</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Nearzon is not liable for any products damaged or lost during shipping. If you received your order damaged, please contact the shipment carrier to file a claim. Please save all packaging materials and damaged goods before filing a claim.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>Contact Support</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        If you have any questions regarding our shipping policy or tracking your order, please reach out to us at <a href="mailto:support@nearzon.com" style={{ color: '#0B1F4D', fontWeight: 600 }}>support@nearzon.com</a>.
                    </Paragraph>
                </Card>
            </div>
            <Footer />
        </div>
    );
};

export default ShippingPolicy;
